/** Presentation only: keep the original labels for tutoring and event identity. */
export function hasWhiteboardInstruction(block: { type: string; prompt?: string }): boolean {
  return (
    Boolean(block.prompt?.trim()) ||
    [
      "slot_sentence",
      "transformation_frame",
      "morphology_grid",
      "pronunciation_focus",
      "phrase_bank_roleplay",
      "listening_discrimination",
      "translation_choice",
    ].includes(block.type)
  );
}
export function showWhiteboardSectionLabel(
  block: { type: string; label?: string; prompt?: string },
  title: string | undefined,
  multiple: boolean
): boolean {
  if (title && block.label?.trim().toLowerCase() === title.trim().toLowerCase()) return false;
  // A question stored in a legacy label is useful instruction, not decoration.
  return (
    multiple ||
    Boolean(block.label && /[?？؟]$/.test(block.label.trim())) ||
    !hasWhiteboardInstruction(block)
  );
}
